import React, {ReactNode} from "react";
import styles from "./SpacedList.module.css";

export function SpacedList({children}: {children: ReactNode}) {
    return (
        <div className={styles.list}>
            {children}
        </div>
    );
}

export function SpacedListItem({children}: {children: ReactNode}) {
    return (
        <div className={styles.item}>
            {children}
        </div>
    );
}
